export default function PHP_reset() {
  return (
    <div>
      <h1>PHP_reset</h1>
    </div>
  );
}
